if (!customElements.get('file-upload')) {
  customElements.define(
    'file-upload',
    class FileUpload extends HTMLElement {
      constructor() {
        super();
        this.fieldWrapper = this.querySelector('.product-form__file-wrapper');
        // Initialize an index for appended file inputs
        this.index = 2;
      }

      connectedCallback() {
        // Add an event listener to the existing button
        const addButton = this.querySelector('button');
        if (addButton) {
          addButton.addEventListener('click', () => this.addFileInput());
        }
      }

      // Function to clone and add a file field input element with an appended index
      addFileInput() {
        const firstFileField = this.querySelector('.field');
        if (firstFileField) {
          // clone the first file field
          const clonedFileField = firstFileField.cloneNode(true);

          // update file input, appending index
          const clonedFileInput = clonedFileField.querySelector('input[type="file"]')
          clonedFileInput.id = `${clonedFileInput.id}-${this.index}`;
          // build the new input name so Shopify can read it as a LIA
          let parts = clonedFileInput.name.split(']');
          clonedFileInput.name = `${parts[0]}-${this.index}]`;
          // remove parts we don't want for additional files
          clonedFileInput.value = ``;
          clonedFileInput.required = false;
          clonedFileInput.ariaRequired = false;


          // update file label, appending index
          const clonedFileLabel = clonedFileField.querySelector('label')
          clonedFileLabel.for = `${clonedFileLabel.for}-${this.index}`;
          if (clonedFileLabel.querySelector('span')){
            clonedFileLabel.querySelector('span').remove();
          }

          // append to the wrapper
          this.fieldWrapper.appendChild(clonedFileField);

          // Increment the index for the next file input
          this.index++;
        }
      }
    }
  );
}